import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Silence the expected 401 that fires on anonymous mount when AuthContext
// probes /auth/me. Any other 401 (or 401 from other endpoints) is re-thrown
// normally.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && url.includes("/auth/me")) {
      // Swallow without noise — caller handles by setting user=false.
      return Promise.reject({ ...err, silent: true });
    }
    return Promise.reject(err);
  },
);

// Normalize FastAPI 422 detail arrays to friendly strings so React never
// renders raw error objects.
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
